import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Modal } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import CompanyLosService from "./../services/company-los-services";
// import shortID from "uuid/v4";
// import { CompanyBankingFacility } from "./../records/index";

const getFormFields = ({
    allFieldsDisabled
}) => new OrderedMap({
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "id",
        //     dataIndex: "id",
        //     label: "Id",
        //     field: {
        //     }
        // })
    },
    bank: {
        key: "bank",
        dataIndex: "bank",
        label: "Bank",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        showSearch: true,
        labelProp: "name",
        // onCell: record => ({
        //     record,
        //     dataIndex: "bank",
        //     label: "Bank",
        //     field: {
        //     }
        // }),
        width: 300
    },
    facility_name: {
        key: "facility_name",
        dataIndex: "facility_name",
        label: "Facility name",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     dataIndex: "facility_name",
        //     label: "Facility name",
        //     field: {
        //     }
        // })
    },
    sanction_limit: {
        key: "sanction_limit",
        dataIndex: "sanction_limit",
        label: "Sanction limit",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     dataIndex: "sanction_limit",
        //     label: "Sanction limit",
        //     field: {
        //     }
        // })
    },
    sanction_year: {
        key: "sanction_year",
        dataIndex: "sanction_year",
        label: "Sanction year",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     dataIndex: "sanction_year",
        //     label: "Sanction year",
        //     field: {
        //     }
        // }),
        // width: 100
    },
    security_or_collateral: {
        key: "security_or_collateral",
        dataIndex: "security_or_collateral",
        label: "Security or Collateral",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     dataIndex: "security_or_collateral",
        //     label: "Security or Collateral",
        //     field: {
        //     }
        // })
    }
});


class CompanyBankingFacilitiesForm extends React.Component {
    state = {
        bankingIds: new Map({}),
        removedIds: [],
        addedBanking: false
    };

    // componentDidMount() {
    //     if(!this.state.bankingIds.size) {
    //         this.toggleFormGrid("ADD");
    //     }
    // }

    // componentDidUpdate() {
    //     if(this.props.values && this.props.values.length && !this.state.addedBanking) {
    //         const values = new List(this.props.values)
    //             .toMap()
    //             .mapEntries(([, v]) => [v.id, v]);
    //         this.setState({
    //             bankingIds: values.map((_, k) => {
    //                 return {
    //                     ..._,
    //                     key: k,
    //                     index: k
    //                 };
    //             }),
    //             addedBanking: true
    //         });
    //     }
    // }

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    getBankList = str =>
        CompanyLosService.getBankList(str).then(({ data }) => {
            return {
                data: data.results
            };
        });

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    let newValues = values;
                    newValues.bank = values.bank && values.bank.id;
                    this.props.onValuesSubmit(newValues);
                }
            });
        }
    }

    // toggleFormGrid = (action = "ADD", id) => {
    //     const { bankingIds } = this.state;
    //     let removedIds = this.state.removedIds;
    //     const newID = shortID();
    //     switch (action) {
    //     case "ADD":
    //         this.setState({
    //             bankingIds: bankingIds.set(newID, {...new CompanyBankingFacility().toJS(), key: newID, index: newID})
    //         });
    //         break;
    //     case "REMOVE": {
    //         removedIds.push(id);
    //         this.setState({
    //             removedIds: removedIds
    //         });
    //         break;
    //     }
    //     default:
    //     }
    // };

    // tableFormCell = () => props => {
    //     const { dataIndex, record, field, ...restProps } = props;
    //     if(dataIndex === "bank") {
    //         field.onSearch = this.getBankList;
    //     }
    //     const index = record.index;
    //     return (
    //         <td {...restProps}>
    //             {this.fieldGenerator(
    //                 `[${index}].${dataIndex}`,
    //                 { ...field, defaultValue: record[dataIndex] },
    //                 this.getValidateStatus(dataIndex)
    //             )()}
    //         </td>);
    // }
    // tableCell = this.tableFormCell(this.props.form);
    render() {
        // const body = {
        //     body: { cell: this.tableCell, row: props => <tr {...props} /> }
        // };
        return (
            <Modal
                width={800}
                bodyStyle={{
                    paddingRight: "3rem",
                    paddingLeft: "3rem"
                }}
                footer={null}
                title="Add/Update Banking Facilities"
                visible={this.props.visible}
                onCancel={this.props.toggleBankingModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                            if(fieldName === "bank") {
                                field.onSearch = this.getBankList;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanyBankingFacilitiesForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleBankingModal: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value) => {
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyBankingFacilitiesForm);